module.exports = __webpack_public_path__ + "img/box9-21.0f940852.png";